import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import { fnGetDataSet, fnGetTableById } from "@shared/api/restApi";
import {
  applySlip,
  CalAm,
  getInitFormData,
  CalAmBulk,
} from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnForm, { ValueChangedEvent, SnFormRef } from "@widgets/SnForm";
import { fnSave } from "@shared/api/restApi";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import { showPopupModal } from "@widgets/CommonModal";
import SN_TRA_EBL_REG_001_POP_001 from "./SN_TRA_EBL_REG_001_POP_001";
import SN_TRA_EBL_REG_001_POP_002 from "./SN_TRA_EBL_REG_001_POP_002";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import SnButton from "@shared/components/SnButton";
import SnResizeBar from "@shared/components/SnResizeBar";
import { dateToString, formatYyyyMMdd } from "@shared/utils/DateUtils";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { RowNode } from "ag-grid-enterprise";

interface Props {
  Menuprops: menuInfo;
  modalRef?: any;
}

const SN_TRA_EBL_REG_001 = forwardRef(({ Menuprops, modalRef }: Props, ref) => {
  const { userInfo } = global();
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [selectedLineDocu, setSelectedLineDocu] = useState<number>(0);
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef(),
  });

  const [gridColumns, setGridColumns] = useState<any>({
    grid1: [],
  });
  const [gridDataSources, setGridDataSources] = useState<any>({
    grid1: [],
  });

  const formRefs = useRef<{ [key: string]: React.RefObject<SnFormRef> }>({
    freeform1: React.createRef(),
  });

  const [formControls, setFormControls] = useState<any>({
    freeform1: [],
  });
  const [formDatas, setFormDatas] = useState<any>({
    freeform1: null,
  });

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onPrint,
  }));

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControls({
          freeform1: rtn.form.freeform1,
        });
        setGridColumns({
          grid1: rtn.grid.grid2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };

  const getFormCurrent = (key: string): SnFormRef => {
    const form = formRefs.current[key]?.current;
    if (!form) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return form;
  };

  const onSearch = async () => {
    const modifiedRowsH = getFormCurrent("freeform1").getChange();
    const modifiedRowsL = getGridCurrent("grid1").getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved: any = await onSave();
        if (!isSaved) return;
      }
    }

    try {
      await search_popup();
    } catch (error) {}
  };

  const search_popup = async () => {
    const selectedData = await getPopupInitialData();
    setSelectedDocu("");
    const component = (
      <SN_TRA_EBL_REG_001_POP_001 selectedData={selectedData} />
    );
    const result = await showPopupModal({
      title: "선적조회",
      children: component,
    });
    if (!result || result === "close") return;
    const headerResult = result[0];
    const newData = { no_sales: headerResult[0].no_sales };
    const params = {
      id: "sn_tra_ebl_reg_001_01",
      params: { ...newData },
    };
    setSelectedDocu(headerResult[0].no_sales);
    getFormCurrent("freeform1").resetUpdate();
    getGridCurrent("grid1").resetUpdate();

    const data: any = await fnGetDataSet(params);

    setFormDatas({
      freeform1: data[0][0],
    });
    setGridDataSources({
      grid1: data[1] || [],
    });
  };

  const getPopupInitialData = async () => {
    let cd_cust = "";
    let nm_cust = "";

    const rowCount = getGridCurrent("grid1").getDisplayedRowCount();
    if (rowCount > 0) {
      const selectedRows = getGridCurrent("grid1").getSelectedRows();
      if (selectedRows.length > 0) {
        cd_cust = selectedRows[0].cd_cust || "";
        nm_cust = selectedRows[0].nm_cust || "";
      }
    }

    return { cd_cust: cd_cust, nm_cust: nm_cust };
  };

  const onInsert = async () => {
    try {
      const modifiedRowsH = getFormCurrent("freeform1").getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        const confirm = await showDialog(
          "confirm",
          "수정중인 건이 있습니다. 저장하지 않고 계속 하시겠습니까?"
        );
        if (!confirm) return;
      }

      getFormCurrent("freeform1").resetUpdate();
      getGridCurrent("grid1")?.deleteAllRows();
      getGridCurrent("grid1").resetUpdate();

      const today = dateToString(new Date());
      const newRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        cd_dept: userInfo.cd_dept,
        nm_dept: userInfo.nm_dept,
        cd_gp: userInfo.cd_gp,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        dt_sales: today,
        dt_issue: today,
        dt_rcv_p: today,
        dt_col_p: today,
        cd_fin: "", // NOT NULL이라 빈 문자열. 회계처리 함수가 빈 값이면 기본형태(001) 계정으로 폴백
        cd_exch: "000",
        no_hst: 1,
        fg_vat: "1",
        cd_person: "N",
        cd_cust_col: "",
        am_vat: 0,
        am_supply: 0,
        no_nego: "N",
        cd_mgmtdtl: "N",
        am_col_s: 0,
        yn_autoprocess: "N",
        // no_docu/no_line_docu는 회계처리(autoslip)가 채우는 전표 키이므로 화면에서 값을 넣지 않는다
        no_line_docu: 0,
        cd_cust_sales: "",
        am_k_col_s: 0,
        fg_etax: "1",
        yn_etax: "Y",
        fg_trns: "4",
        am: 0,
        am_k: 0,
        yn_docu: "N",
      };
      getFormCurrent("freeform1").addRow(newRow);
    } catch (error: any) {}
  };

  const onAddRow = () => {
    try {
      const maxNoLine = getGridCurrent("grid1").getMaxValue("no_line");

      const formData = getFormCurrent("freeform1").getFormdata();
      const nosales = formData?.no_sales;
      const newRow = {
        cd_firm: userInfo.cd_firm,
        no_sales: nosales,
        no_line: maxNoLine + 1,
      };
      return getGridCurrent("grid1")?.addRow(newRow);
    } catch (error: any) {}
  };

  const onDelete = async () => {
    if (!getFormCurrent("freeform1").checkDataExist()) return;

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;
    getFormCurrent("freeform1")?.deleteForm();
    getGridCurrent("grid1")?.deleteAllRows();
    await onSave();
  };

  const onDeleteRow = async () => {
    if (getGridCurrent("grid1")?.getDisplayedRowCount() < 1) return;
    getGridCurrent("grid1")?.deleteSelectedRows();
  };

  const onSave = async () => {
    let salSalesHChanges;
    let salSalesLChanges;
    try {
      getGridCurrent("grid1")?.stopEditing();

      const requiredValuesCheckH =
        getFormCurrent("freeform1").requiredValuesCheck();
      if (!requiredValuesCheckH) return;

      const requiredValuesCheckL =
        getGridCurrent("grid1").requiredValuesCheck();
      if (!requiredValuesCheckL) return;

      salSalesHChanges = getFormCurrent("freeform1").getChange();
      salSalesLChanges = getGridCurrent("grid1").getChange();
      if (
        salSalesHChanges.modifiedRowcount === 0 &&
        salSalesLChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }
      const headerInserts = salSalesHChanges.insert ?? [];
      if (headerInserts.length > 0) {
        const focusedRowNodeH = getFormCurrent("freeform1").getFormdata();
        if (
          focusedRowNodeH.no_sales !== "" &&
          focusedRowNodeH.no_sales !== undefined
        ) {
          const payload = {
            id: "duplication_sales",
            params: {
              cd_firm: userInfo.cd_firm,
              no_sales: focusedRowNodeH.no_sales,
            },
          };
          const noSales_duplication = await fnGetTableById(payload);
          if (noSales_duplication.length > 0) {
            await showDialog(
              "alert",
              "선적일 " +
                formatYyyyMMdd(noSales_duplication[0].dt_sales) +
                "기준 등록된 선적번호 입니다"
            );
            return;
          } else {
            salSalesLChanges.insert.forEach((row: any) => {
              row.no_sales = focusedRowNodeH.no_sales;
            });
          }
        } else {
          const noSlip = await applySlip({
            cd_column: "no_sales",
            cd_module: Menuprops.cd_module,
            no_line: 2,
            cd_prefix: "EBL",
            dt: focusedRowNodeH.dt_sales,
            girdrefs: [gridRefs.current["grid1"]],
            formrefs: [formRefs.current["freeform1"]],
            inserts: [salSalesHChanges, salSalesLChanges],
            cd_menu: Menuprops.cd_menu,
          });
        }
      }
      const saveData = {
        sal_salesh: salSalesHChanges,
        sal_salesl: salSalesLChanges,
      };
      const ok = await fnSave("SN_TRA_EBL_REG_001_SAVE_01", saveData);
      if (!ok) {
        getFormCurrent("freeform1").resetUpdate(true);
        getGridCurrent("grid1").resetUpdate(true);
        return false;
      }

      getFormCurrent("freeform1").resetUpdate();
      getGridCurrent("grid1").resetUpdate();
      return true;
    } catch (error: any) {
      getFormCurrent("freeform1").resetUpdate(true);
      getGridCurrent("grid1").resetUpdate(true);
      return false;
    }
  };

  const onPrint = async () => {
    getGridCurrent("grid1").stopEditing();

    const formInfo = getFormCurrent("freeform1").getFormdata();
    if (!formInfo || Object.keys(formInfo).length === 0) {
      await showDialog("alter", "선택된 선적정보가 없습니다.");
      return;
    }
    return {
      cd_firm: userInfo.cd_firm,
      cd_biz: formInfo.cd_biz,
      no_sales: formInfo.no_sales,
    };
  };

  const onGridBtnsClick = async (id: string) => {
    if (id === "deleteRow") {
      onDeleteRow();
    }
    if (id === "searchPopUp") {
      const modifiedRowH = getFormCurrent("freeform1").getChange();
      if (modifiedRowH.insert.length == 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }

      const component = (
        <SN_TRA_EBL_REG_001_POP_002
          selectedData={{ cd_biz: userInfo.cd_biz }}
        />
      );
      const result = await showPopupModal({
        title: "출하적용",
        children: component,
        width: "80%",
        height: "95%",
        validation: true,
      });
      if (!result || result === "close") return;

      const headerResult = result[0];
      const lineResult: any[] = result[1];

      if (headerResult[0]) {
        for (const key in headerResult[0]) {
          getFormCurrent("freeform1").setDataValue(
            key,
            headerResult[0][key],
            "noEvent"
          );
        }
        getFormCurrent("freeform1").setDataValue(
          "cd_cust_col",
          headerResult[0].cd_cust,
          "noEvent"
        );
        getFormCurrent("freeform1").setDataValue(
          "cd_cust_sales",
          headerResult[0].cd_cust,
          "noEvent"
        );
      }

      const cd_exch = headerResult[0].cd_exch;

      lineResult.map((result: any) => {
        if (headerResult[0]) {
          const addedNode = onAddRow();
          if (addedNode) {
            const prevNoLine = addedNode.data.no_line;
            for (const key in result) {
              if (key === "qt") continue;
              addedNode.setDataValue(key, result[key], "noEvent");
            }
            addedNode.setDataValue("qt", result.qt_app, "noEvent");
            addedNode.setDataValue("cd_exch", cd_exch, "noEvent");
            addedNode.setDataValue("no_io", "", "noEvent");
            addedNode.setDataValue("no_line", prevNoLine, "noEvent");
            addedNode.setDataValue("no_line_isu", result.no_line, "noEvent");
            addedNode.setDataValue("no_isu", result.no_io, "noEvent");
            addedNode.setDataValue("no_so", result.no_order, "noEvent");
            addedNode.setDataValue(
              "no_line_so",
              result.no_line_order,
              "noEvent"
            );
          }
        }
      });

      await CalAmBulk(
        formRefs.current["freeform1"],
        gridRefs.current["grid1"],
        "rt_exch"
      );
    }
  };

  const onValueChaged = async (event: ValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    if (colId === "cd_cust") {
      return {
        cd_cust_col: rowData.cd_cust,
        cd_cust_sales: rowData.cd_cust,
      };
    }

    await CalAmBulk(
      formRefs.current["freeform1"],
      gridRefs.current["grid1"],
      colId
    );
  };

  const onCellValueChanged2 = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    await CalAm(
      formRefs.current["freeform1"],
      gridRefs.current["grid1"],
      colId
    );
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: gridColumns.grid1,
        dataSource: gridDataSources.grid1,
        events: {
          onBtnDeleteClick: onDeleteRow,
          onCellValueChanged: onCellValueChanged2,
        },
      },
    }),
    [gridColumns, gridDataSources]
  );

  const forms = useMemo(
    () => ({
      freeform1: {
        controls: formControls.freeform1,
        data: formDatas.freeform1,
        etcProps: {},
        events: {
          onValueChanged: onValueChaged,
        },
      },
    }),
    [formControls, formDatas]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="64.5%">
          <SnForm
            ref={formRefs.current["freeform1"]}
            controls={forms.freeform1.controls}
            data={forms.freeform1.data}
            events={forms.freeform1.events}
          ></SnForm>
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="34%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single", title: "선적내역" }}
            events={grids.grid1.events}
            header={
              <div>
                <SnButton
                  text={"출하적용"}
                  onClick={() => {
                    onGridBtnsClick("searchPopUp");
                  }}
                />
              </div>
            }
          />
        </SnResizeBar>
        <SnFileUploadBox
          selectedDocu={selectedDocu}
          selectedLineDocu={selectedLineDocu}
        />
      </div>
    </div>
  );
});

export default SN_TRA_EBL_REG_001;
